import { paths } from '@Components/configs';
import {
  ADMIN_AUTH_LOG_IN,
  ADMIN_AUTH_LOG_OUT,
  ADMIN_AUTH_REFRESH,
} from '../actionTypes';
import * as api from '../apiHelper';
import { initiateRedirectRequest } from '../redirectActions';
import { setAppLoaderReset, setAppLoaderReady } from '../appLoaderActions';
import { arriveNotice } from '../noticeActions';

// --- Reducer corresponding actions ---
export function adminLogIn(json, token) {
  const adminEmail = json?.email || null;
  const payoutDashboardAccess = json?.payout_dashboard_access === true;
  return { type: ADMIN_AUTH_LOG_IN, payload: { token, adminEmail, payoutDashboardAccess } };
}

export function adminLogOut() {
  return { type: ADMIN_AUTH_LOG_OUT };
}

export function adminRefresh(token) {
  return { type: ADMIN_AUTH_REFRESH, payload: { token } };
}

// --- API functions ---
async function adminLogInApi(email, password) {
  const body = {
    user: { email, password },
    role: 'ADMIN',
  };
  const response = await api.post({
    path: 'auth/login',
    version: 'gateway',
    body,
    token: null,
  });
  const json = await response.json();
  const token = response.headers.get('Authorization')?.replace('Bearer ', '');
  return { json, token };
}

async function adminLogOutApi(token) {
  await api.del({
    path: 'auth/logout',
    version: 'gateway',
    token,
  });
}

async function adminRefreshApi(token) {
  const response = await api.post({
    path: 'auth/refresh',
    version: 'gateway',
    token,
  });
  const json = await response.json();
  return { json, token };
}

// --- Public components actions ---
export function adminLogInRequest(email, password) {
  return async (dispatch) => {
    try {
      dispatch(setAppLoaderReady());
      const { json, token } = await adminLogInApi(email, password);
      dispatch(adminLogIn(json, token));
      dispatch(initiateRedirectRequest(null, paths.root));
      dispatch(setAppLoaderReset());
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(arriveNotice(e.message));
        dispatch(setAppLoaderReset());
      }
    }
  };
}

export function adminLogOutRequest() {
  return async (dispatch, getState) => {
    try {
      const { adminToken } = getState().adminAuth;
      dispatch(setAppLoaderReady());
      await adminLogOutApi(adminToken);
      dispatch(adminLogOut());
      dispatch(setAppLoaderReset());
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(arriveNotice(e.message));
        dispatch(setAppLoaderReset());
      }
    }
  };
}

export function adminRefreshRequest() {
  return async (dispatch, getState) => {
    try {
      const { adminToken } = getState().adminAuth;
      await adminRefreshApi(adminToken);
      dispatch(adminRefresh(adminToken));
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(adminLogOut());
        dispatch(arriveNotice(e.message));
      }
    }
  };
}
